// Poemcard.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './poemcss.css';

function Poemcard({ image_url, title, id, description, price }) {
  const navigate = useNavigate();

  // if (!image_url || !title || !description || !price) return null;

  // const handleClick = () => {
  //   localStorage.setItem(
  //     'selectedPoem',
  //     JSON.stringify({ title, id, description, price })
  //   );
  //   navigate('/billing');
  // };

  const handleClick = () => {
    navigate(`/buyerszone?tab=Books`);
  };

  return (
    <div className="poem-card">
      <img src={image_url} alt="book image" className="poem-card__image" />
      {/* <h3 className="poem-card__price">{price}</h3> */}
      <div>
        <button className="poem-card__button" onClick={handleClick}>
          Buyer's Zone
        </button>
      </div>

      <p dangerouslySetInnerHTML={{ __html: description }} />

    </div>
  );
}

export default Poemcard;
